import {
  GetWebGatewayData,
  getWebGatewayTaskList,
  getWebDetail,
  GetWebDetail,
  getListDetails,
  GetListDetails,
  getListDetailsElement,
  GetListDetailsElement,
  deleteList,
  DeleteList,
  getRefs,
  GetJobResultStartTimeList,
  getJobResultStartTimeList,
  getBizAreaList,
  generateReport,
  GenerateReport,
  stopTask,
  retestTask,
  getTaskDetailUseCaseStatus,
  getTaskDetailUseCaseCount,
  getTaskDetail,
  getGroupList,
  getTaskExecList,
  getResultList,
  deleteTask,
  TaskListProps,
  getSecurityDeviceList,
  getAgentList,
  getTaskDetailTemplateList,
  getTaskDetailCaseList,
  getTaskDetailCaseAttackType,
} from '@/api/web-list-task'
import { ChangeJobStatus, changeJobStatus } from '@/api/web-plans-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'
export const useGetWebGatewayTaskList = props => {
  const { params } = props
  const { runAsync: run, data } = useRequest(() => getWebGatewayTaskList(params), {
    refreshDeps: [params],
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [data?.data || {}, run] as const
}
export const useGetBizAreaList = () => {
  const { runAsync: run, data } = useRequest(() => getBizAreaList(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}

export const useGetWebDetail = () => {
  const { runAsync: run } = useRequest((params: GetWebDetail) => getWebDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表数量失败'))
    },
  })

  return [run] as const
}
// 获取模板列表
export const useGetListDetails = () => {
  const { runAsync: run } = useRequest((params: GetListDetails) => getListDetails(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取模板列表详情失败'))
    },
  })

  return [run] as const
}
// 获取URL列表
export const useGetListDetailsElement = props => {
  const { listDetailsElementParams } = props
  const { runAsync: run, data } = useRequest(
    () => getListDetailsElement(listDetailsElementParams),
    {
      refreshDeps: [listDetailsElementParams],
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取URL列表失败'))
      },
    },
  )

  return [run, data?.data] as const
}
// 获取开始时间列表
export const useGetJobResultStartTimeList = () => {
  const { runAsync: run } = useRequest(
    (params: GetJobResultStartTimeList) => getJobResultStartTimeList(params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('获取开始时间列表失败'))
      },
    },
  )

  return [run] as const
}
// 删除列表
export const useDeleteList = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteList) => deleteList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除列表失败'))
    },
  })
  return [run, loading] as const
}
// 获取模板列表refs
export const useGetRefs = () => {
  const { runAsync: run } = useRequest(() => getRefs(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取模板列表refs失败'))
    },
  })
  return [run] as const
}

export const useGenerateReport = () => {
  const { runAsync: run } = useRequest((data: GenerateReport) => generateReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('创建报表失败'))
    },
  })
  return [run] as const
}

// 停止任务
export const useStopTask = () => {
  const { runAsync: run } = useRequest(data => stopTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务停止失败'))
    },
  })
  return [run] as const
}

//任务复测
export const useReTestTask = () => {
  const { runAsync: run, loading } = useRequest(data => retestTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务复测失败'))
    },
  })
  return [run, loading] as const
}

// 获取任务详情用例状态列表
export const useGetTaskDetailUseCaseStatus = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailUseCaseStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取例状态列表失败'))
    },
  })
  return [run, data?.data?.list || []] as const
}

// 任务结果 根据用例状态统计用例数
export const useGetTaskDetailUseCaseCount = () => {
  const { runAsync: run } = useRequest(params => getTaskDetailUseCaseCount(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例状态统计失败'))
    },
  })
  return [run] as const
}

// 获取任务详情
export const useGetTaskDetail = () => {
  const { runAsync: run } = useRequest((id: string) => getTaskDetail(id), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务详情失败'))
    },
  })

  return [run] as const
}

// 获取分组列表 (筛选)
export const useGetGroupList = () => {
  const { runAsync: run, data } = useRequest((params: any) => getGroupList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取分组列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 主任务删除
export const useDeleteTask = () => {
  const { runAsync: run, loading } = useRequest((taskIds: string[]) => deleteTask(taskIds), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除任务失败'))
    },
  })

  return [run, loading] as const
}

// 子任务列表
export const useGetTaskExecList = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((id: string, params: TaskListProps) => getTaskExecList(id, params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务执行列表失败'))
    },
  })

  return [run, loading, data?.data?.items || []] as const
}

// 获取任务列表
export const useGetTaskList = () => {
  const { runAsync: run, loading } = useRequest((params: TaskListProps) => getResultList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务列表失败'))
    },
  })

  return [run, loading] as const
}

// 获取安全设备列表 (筛选)
export const useGetSecurityDeviceList = () => {
  const { runAsync: run, data } = useRequest(() => getSecurityDeviceList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全设备列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 执行主体
export const useGetAgentList = () => {
  const { runAsync: run, data } = useRequest(() => getAgentList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全设备列表失败'))
    },
  })

  return [run, data?.data?.list || []] as const
}

// 任务详情关联模板列表
export const useGetTaskDetailTemplateList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联模板列表失败'))
    },
  })

  return [run, loading] as const
}

// 任务详情关联模板获取用例列表
export const useGetTaskDetailCaseList = () => {
  const { runAsync: run, loading } = useRequest(params => getTaskDetailCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联模板用例列表失败'))
    },
  })

  return [run, loading] as const
}

// 任务详情关联模板用例攻击类型列表
export const useGetTaskDetailCaseAttackType = () => {
  const { runAsync: run, data } = useRequest(params => getTaskDetailCaseAttackType(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联模板用例攻击类型失败'))
    },
  })

  return [run, data?.data?.attackTypeFilters || []] as const
}

// 暂停/重启计划任务
export const useChangeJobStatus = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobStatus(params), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '暂停/重启计划任务')
    },
  })

  return [run] as const
}
